export default "__VITE_ASSET__BIl2bmbd__"